<script>
import DatePicker from "vue2-datepicker";
import forEach from "lodash/forEach";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
export default {
  props: {
    items: {},
  },
  components: {
    DatePicker,
    MaskedInput,
  },
  data() {
    return {
      records: this.items,
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [5, 10, 20, 50, 100],
      filter: null,
      filterOn: [],
      sortDesc: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      fields: [
        {
          key: "isChecked",
          label: " ",
          thStyle: { width: "2%" },
        },
        {
          key: "name",
          label: "Expenditure/Account",
          thStyle: { width: "25%" },
        },
        {
          key: "amount",
          label: "Amount",
          thStyle: { width: "15%" },
        },
        // {
        //   key: "isExclusive",
        //   label: "Exclusive",
        //   thStyle: { width: "10%" },
        // },
        {
          key: "forCharging",
          label: "Centrally-Managed Item",
          thStyle: { width: "10%" },
          tdClass: "text-center",
        },
        {
          key: "validity",
          thStyle: { width: "15%" },
          tdClass: "text-center",
        },
      ],
      tableBusy: false,
      selectAll: false,
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    formatDate(data) {
      return new Date(data).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    toggleSelect() {
      if (this.selectAll) {
        forEach(this.items, (item) => {
          item.isChecked = true;
        });
      } else {
        forEach(this.items, (item) => {
          item.isChecked = false;
        });
      }
    },
    checkBalance(row, event) {
      const prev = row.item.amount;
      row.item.amount = event;

      if (Number(this.getExactAmt(row.item.amount)) > row.item.balance) {
        row.item.amount = prev;
        this.showToast(
          "Insufficient Balance! The amount entered is greater than the balance",
          "error"
        );
        return false;
      }
    },
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
};
</script>

<template>
  <div>
    <div
      id="datatable_wrapper"
      class="dataTables_wrapper dt-bootstrap4 no-footer"
    >
      <div class="row mb-3">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Show&nbsp;
              <b-form-select
                class="form-select form-select-sm mx-1"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
              ></b-form-select
              >&nbsp;entries
            </label>
          </div>
        </div>
        <!-- Search -->
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label class="d-inline-flex align-items-center">
              Search:
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Search..."
                class="form-control form-control-sm ms-2"
              ></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>
      <div class="row">
        <!-- table data -->
        <div class="col-lg-12">
          <div class="table-responsive">
            <b-table
              class="table project-list-table table-nowrap align-middle table-borderless"
              sticky-header="true"
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :busy="tableBusy"
              @filtered="onFiltered"
              show-empty
            >
              <template #empty="scope">
                <div class="text-center">
                  <h5 class="text-secondary">{{ scope.emptyText }}</h5>
                </div>
              </template>
              <template #table-busy>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template #cell(isChecked)="row">
                <div class="form-check mt-1 ms-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="row.item.isChecked"
                  />
                </div>
              </template>
              <template #cell(validity)="row">
                <date-picker
                  :first-day-of-week="1"
                  lang="en"
                  value-type="date"
                  v-model="row.item.expiry"
                ></date-picker>
              </template>
              <template #cell(amount)="row">
                <masked-input
                  autocomplete="off"
                  type="text"
                  :value="row.item.amount"
                  placeholder="Enter Amount..."
                  class="form-control w-75 d-inline-block me-3"
                  :mask="currencyMask"
                  @input="checkBalance(row, $event)"
                ></masked-input>
              </template>
              <template #cell(name)="row">
                <p class="my-0">
                  <span class="badge rounded-pill bg-success">{{
                    row.item.uacs
                  }}</span>
                  {{ row.item.name }}
                </p>
                <p class="my-0">
                  <small
                    >Balance:
                    <strong class="text-info">{{
                      formatCurrency(row.item.balance)
                    }}</strong></small
                  >
                </p>
              </template>
              <template #head(isChecked)>
                <div class="form-check mt-1 ms-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="selectAll"
                    @change="toggleSelect"
                  />
                </div>
              </template>
              <template #cell(forCharging)="row">
                <div class="form-check mt-1 ms-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="row.item.forCharging"
                  />
                </div>
              </template>
              <!-- <template #cell(isExclusive)="row">
                <div class="form-check mt-1 ms-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="row.item.isExclusive"
                  />
                </div>
              </template> -->
            </b-table>
          </div>
        </div>
        <!-- table data -->
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
